<template>
  <ReactPage>
    <consumer-raffle-event-winner-report-page></consumer-raffle-event-winner-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "ConsumerRaffleEventWinnerReport",
  components: {
    ReactPage
  }
}
</script>